import $ from 'jquery';
import throttle from 'lodash.throttle';
import { libNodes } from '../utils/Utils';
import 'lightgallery';
import 'lightgallery/modules/lg-thumbnail';
import { calcFontSize, nullFontSize } from './Accessability';

let cameFrom = null;
const triggetOffset = 800;
let loading = false;
let end = false;

let dataUrlItems = null;
let dataUrlItem = null;

const $publicationModalTemplate = $(
    `<div class="publication_modal modal">
        <div class="decoration glossary__decoration">
            <div class="decoration__square decoration__square--rounded"></div>
            <div class="decoration__circles"></div>
        </div>
        <div class="publication_modal__inner">
            <div class="publication_modal__controls">
                <a class="publication_modal__back"></a>
                <button class="btn btn--close publication_modal__close" type="button" title="Закрыть">
                    <svg class="icon icon--plus publication_modal__icon_close">
                        <use xlink:href="/static/img/svg/sprite.svg#plus"></use>
                    </svg>
                </button>
            </div>
            <div class="publication_modal__content"></div>
        </div>
    </div>`
);

const loadData = async (url, hash) => {
    await $.ajax({
        type: 'get',
        url: url
    })
        .done(function(data) {
            let $publication = $(data.content);

            $publicationModalTemplate
                .children('.publication_modal__inner')
                .removeClass('publication_modal__inner--loading')
                .children('.publication_modal__content')
                .append($publication);

            $publication
                .attr('data-publication', data.id)
                .find('.js_gallery')
                .lightGallery({
                    selector: '.gallery__item',
                    download: false,
                    thumbnail: true
                });

            history.replaceState(null, '', hash);
        })
        .fail(function() {
            if ($publicationModalTemplate.find('.publication_modal__content').children().length === 0) {
                $publicationModalTemplate.find('.publication_modal__content').html(
                    `<article class="publication">
                            <div class="publication__content">
                                <div class="text">
                                    <h3>Произошла ошибка при загрузке данных</h3>
                                </div>
                            </div>
                        </article>`
                );
            }

            end = true;
        })
        .always(function() {
            loading = false;
        });
};

const init = () => {
    $('body').on('click', '[data-el-type="publication"]', async function(e, onLoad = false) {
        e.preventDefault();
        cameFrom = `${$(this).attr('data-back-link')}`;

        let publicationUrl = this.href;

        $publicationModalTemplate
            .appendTo('body')
            .fadeIn(700)
            .children('.publication_modal__inner')
            .addClass('publication_modal__inner--loading')
            .find('.publication_modal__back')
            .text(`${$(this).attr('data-back-text')}`)
            .attr('href', cameFrom);

        libNodes.$html.addClass('modal_opened');
        loadData(publicationUrl, publicationUrl).then(() => {
            if (!onLoad) {
                nullFontSize('.publication_modal');
                calcFontSize('.publication_modal');
            }
        });

        history.replaceState(null, this.textContent, publicationUrl);

        // let current = this;
        // TODO: переделать это говно
        // $publicationModalTemplate.on(
        //     'scroll',
        //     throttle(() => {
        //         if (
        //             $publicationModalTemplate.scrollTop() >=
        //             $publicationModalTemplate[0].scrollHeight - triggetOffset - window.innerHeight &&
        //             !loading &&
        //             !end
        //         ) {
        //             loading = true;
        //             let next = $(current).closest('li').next().find('a');
        //             console.log(next);
        //             loadData(next.href, next.href);
        //             current = next;
        //         }
        //
        //         $('.publication_modal .publication').each(function () {
        //             const $currentPublication = $(this);
        //
        //             if ($currentPublication.offset().top < 0) {
        //                 if (
        //                     $currentPublication.innerHeight() + $currentPublication.offset().top >
        //                     window.innerHeight / 2
        //                 ) {
        //                     history.replaceState(null, $currentPublication.textContent, `${$currentPublication.attr('data-url')}`);
        //                 }
        //             } else {
        //                 if (window.innerHeight - $currentPublication.offset().top > window.innerHeight / 2) {
        //                     history.replaceState(null, $currentPublication.textContent, `${$currentPublication.attr('data-url')}`);
        //                 }
        //             }
        //         });
        //     }, 100)
        // );
    });

    $(`[data-el-type="publication"][href$="${location.pathname}"]`)
        .eq('0')
        .trigger('click', true);

    $('body').on('click', '.publication_modal__close', function() {
        const $modal = $(this).closest('.publication_modal');

        history.replaceState(null, '', cameFrom);

        dataUrlItem = 1;
        end = false;
        loading = false;

        $publicationModalTemplate.off('scroll');

        $modal.fadeOut(700, () => {
            $modal
                .find('.publication_modal__content')
                .empty()
                .end()
                .remove();

            libNodes.$html.removeClass('modal_opened');
        });
    });
};

export default init();
